// ----------------------------------------------------------------------
// <copyright file="Izenda.List.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module CollapsibleList component
 * @example
 *   <CollapsibleList>
 *     <CollapsibleList.Item>
 *       <CollapsibleList.ItemHeader>
 *       </CollapsibleList.ItemHeader>
 *       <CollapsibleList.ItemBody>
 *       </CollapsibleList.ItemBody>
 *     </CollapsibleList.Item>
 *   </CollapsibleList>
 */
!(function() {
  var React = require('react');

  var classnames = require('classnames');
  var m = require('mobx');
  var observer = require('mobx-react').observer;
  const { omit, each, concat, find, castArray, chain, isNil, isString, invoke } = require('lodash/fp');
  var excludeProps = omit;

  var CollapsibleList = React.createClass({
    propTypes: {
      autoCollapse: React.PropTypes.bool,
      defaultExpand: React.PropTypes.bool
    },
    getDefaultProps: function() {
      return {
        autoCollapse: true,
        defaultExpand: false
      };
    },
    render: function() {
      return (
        <div
          {...excludeProps(['children', 'autoCollapse', 'defaultExpand', 'afterToogleCallback'], this.props)}
          data-container="true"
        >
          {this.renderItems()}
        </div>
      );
    },

    renderItems: function() {
      var isItem = each(function(child) {
        return child.type === 'Item';
      });

      ensure(isItem(this.props.children), 'Child item of CollapsibleList must be CollapsibleList.Item');
      var children = castArray(this.props.children);

      return children.map(
        function(child) {
          return React.cloneElement(child, {
            autoCollapse: this.props.autoCollapse,
            defaultExpand: this.props.defaultExpand
          });
        }.bind(this)
      );
    }
  });

  CollapsibleList.Item = observer(
    React.createClass({
      getDefaultProps: function() {
        return {
          autoCollapse: true,
          defaultExpand: false
        };
      },
      componentWillMount: function() {
        this.defaultExpand = this.props.itemExpanded || !!this.props.defaultExpand;
        this.observableProps = m.observable({
          expanded: this.defaultExpand
        });
      },
      componentDidMount: function() {
        this.defaultExpand = false;
      },
      render: function() {
        var header = this.renderChildByType('ItemHeader');
        var body = this.renderChildByType('ItemBody', true);

        var finalHeader = React.cloneElement(header, {
          expanded: this.observableProps.expanded,
          autoCollapse: this.props.autoCollapse,
          toggleCollapse: this.toggleCollapse
        });

        var finalBody = body
          ? React.cloneElement(body, {
              expanded: this.observableProps.expanded,
              defaultExpand: this.defaultExpand,
              afterToogleCallback: this.props.afterToogleCallback,
              ref: 'itemBody'
            })
          : undefined;

        var rest = excludeProps(
          [
            'children',
            'autoCollapse',
            'defaultExpand',
            'itemExpanded',
            'toggleCollapse',
            'expanded',
            'afterToogleCallback'
          ],
          this.props
        );

        return (
          <div {...rest} aria-expanded={this.observableProps.expanded}>
            {finalHeader}
            {finalBody}
          </div>
        );
      },
      renderChildByType: function(childType, optional) {
        var foundChild = find(function(child) {
          return child.type.displayName === childType;
        })(concat([], this.props.children));

        ensure(optional || foundChild, 'CollapsibleList.Item must have %s', childType);

        return foundChild;
      },

      toggleCollapse: m.action(function() {
        this.refs.itemBody && this.refs.itemBody.collapse(this.observableProps);
      })
    })
  );

  CollapsibleList.ItemHeader = React.createClass({
    render: function() {
      var props = this.props;

      var safeChildren = chain(props.children)
        .castArray()
        .filter(function(item) {
          return !isNil(item);
        })
        .value();

      var rest = excludeProps(['children', 'expanded', 'autoCollapse', 'toggleCollapse', 'afterToogleCallback'], props);
      return (
        <div onClick={props.autoCollapse ? props.toggleCollapse : null} aria-expanded={props.expanded} {...rest}>
          {safeChildren.map(function(child) {
            if (isString(child.type)) {
              return child;
            }
            return React.cloneElement(child, {
              toggleCollapse: props.toggleCollapse
            });
          })}
        </div>
      );
    }
  });
  CollapsibleList.ItemBody = React.createClass({
    // this property only affect first render
    componentWillMount: function() {
      this.defaultExpand = this.props.defaultExpand;
      this.animationStatus = false;
    },
    componentWillUnmount: function() {
      this.dom && $izenda(this.dom).off('hide.bs.collapse show.bs.collapse hidden.bs.collapse shown.bs.collapse');
    },
    setDom: function(dom) {
      if (this.dom && this.dom !== dom) {
        $izenda(this.dom).off('hide.bs.collapse show.bs.collapse hidden.bs.collapse shown.bs.collapse');
        this.endAnimation();
      }
      this.dom = dom;
      dom &&
        $izenda(dom)
          .off('hide.bs.collapse show.bs.collapse hidden.bs.collapse shown.bs.collapse')
          .on('hide.bs.collapse show.bs.collapse', this.startAnimation)
          .on('hidden.bs.collapse shown.bs.collapse', this.endAnimation);
    },
    render: function() {
      var props = this.props;

      var classes = classnames(props.className, 'collapse', {
        in: this.defaultExpand
      });
      var rest = excludeProps(
        ['children', 'className', 'defaultExpand', 'toggleCollapse', 'expanded', 'afterToogleCallback'],
        props
      );

      return (
        <div className={classes} ref={this.setDom} aria-expanded={props.expanded} {...rest}>
          {props.children}
        </div>
      );
    },
    startAnimation: function() {
      this.animationStatus = true;
    },
    endAnimation: function() {
      this.animationStatus = false;
      invoke('afterToogleCallback', this.props);
    },
    collapse: function(observerObject) {
      this.defaultExpand = false;
      if (!this.animationStatus) {
        var expanded = (observerObject.expanded = !observerObject.expanded);
        $izenda(this.dom).collapse(expanded ? 'show' : 'hide');
      }
    }
  });

  module.exports = CollapsibleList;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.CollapsibleList.jsx